import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES, Retorno, StatusRetorno } from '@philips-emr/hpms-stipulator-commons';
import { ButtonAPI, FieldAPI, FormAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnChange, OnClick, OnClose, OnValidate } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation';

import './reset-password-controller.scss';
import { FragmentNames } from '../../codegen';

@Controller({ fragment: FragmentNames.RESET_PWD })
class ResetPasswordController {

  @Inject('form-reset-password')
  private formResetPassword: FormAPI;

  @Inject('panel-loader')
  private panelLoader: PanelAPI;

  @Inject('panel-actions')
  private panelActions: PanelAPI;

  @Inject('panel-success')
  private panelSuccess: PanelAPI;

  @Inject('panel-screen')
  private panelScreen: PanelAPI;

  @Inject('field-recaptcha')
  private fieldRecaptcha: FieldAPI;

  @Inject('button-confirm')
  private buttonConfirm: ButtonAPI;

  @Inject('toast-notification')
  private toastNotificationApi: ToastNotificationAPI;

  @OnClose({ target: 'modal-reset-password' })
  onClose(): void {
    applicationContext.redirect(FOUNDATION_ROUTES.LOGIN);
  }

  @OnClose({ target: 'toast-notification' })
  onCloseToast(): void {
    this.toastNotificationApi.setVisible(false);
  }

  @OnValidate({ target: 'form-reset-password' })
  onValidateForm(event: ValidateEvent): void {
    const { valid } = event;

    this.buttonConfirm.setEnabled(valid);
  }

  @OnChange({ target: 'form-reset-password' })
  onChangeForm(): void {
    if (this.toastNotificationApi.isVisible()) {
      this.toastNotificationApi.setVisible(false);
    }
  }

  @OnClick({ target: ['button-confirm'] })
  onClick(): void {
    if (this.formResetPassword.validate()) {
      this.panelLoader.setVisible(true);
      this.panelActions.setVisible(false);

      const { username } = this.formResetPassword.getRecord();
      const body = { nmUsuarioWeb: username };

      HttpService.post<Retorno<string>>(Endpoint.POST.RESET_PASSWORD, {}, { body })
        .then(() => {
          this.panelScreen.setVisible(false);
          this.panelSuccess.setVisible(true);
        }).catch(resp => {
          const { body: respBody } = resp;

          this.panelLoader.setVisible(false);
          this.panelActions.setVisible(true);

          const w = window as unknown as { grecaptcha: { reset: Function } };
          this.fieldRecaptcha.setValue('');
          w.grecaptcha.reset();

          this.resetValidations();

          const { response, status } = respBody;

          if (status === StatusRetorno.WARNING) {
            this.showToastForm(ToastLevel.WARNING, response);
            return;
          }

          this.showToastForm(ToastLevel.ERROR, resp.body);
        });
    }
  }

  private showToastForm(level: ToastLevel, msg: string): void {
    this.toastNotificationApi.setMessage(msg);
    this.toastNotificationApi.setVisible(true);
    this.toastNotificationApi.setLevel(level);
  }

  private resetValidations(): void {
    this.formResetPassword.setEditing(false);
    this.formResetPassword.setEditing(true);
  }

  @OnClick({ target: ['button-ok'] })
  onClickOk(): void {
    applicationContext.redirect(FOUNDATION_ROUTES.LOGIN);
  }

  @OnAfterFetch({ target: ['fetch-recaptcha'] })
  onAfterFetch(event: FetchEvent): void {
    if(!event.data) {
      return;
    }
    this.formResetPassword.setLoading(false);
  }

}

export default ResetPasswordController;
